import { fetchFooterLinksFromSanity } from '../fetchData'
import { Footer_v2, NavigationItem_v2, SubMenuItem_v2 } from '@fjordline/sanity-types'
import { useQuery } from '@tanstack/react-query'

function getLinksWithAbsolutePaths(data: Footer_v2) {
  const baseUrl = 'https://www.fjordline.com'
  const footerLinks = data[0].items?.map((link: NavigationItem_v2) => {
    const footerSubmenuLinks = link.subMenu?.map((subLink: SubMenuItem_v2 & { _key: string }) => {
      return {
        ...subLink,
        href: subLink.href?.startsWith('http') || !subLink.href ? subLink.href : `${baseUrl}${subLink.href}`,
      }
    })

    return {
      ...link,
      href: link.href?.startsWith('http') || !link.href ? link.href : `${baseUrl}${link.href}`,
      subMenu: footerSubmenuLinks,
    }
  })
  
  data[0].items = footerLinks
  return {
    ...data,
  }
}

function useFetchFooter(language: string) {
  return useQuery({
    queryKey: [language],
    enabled: language ? true : false,
    queryFn: async () => {
      if (language && language.length > 0) {
        const data = (await fetchFooterLinksFromSanity(language)) as Footer_v2
        return getLinksWithAbsolutePaths(data)
      }
    },
  })
}

export default useFetchFooter
